<template>
  <ul
    class="overview-item-group "
  >
    <li :class="{ 'featured-group-heading': group.areaTitle === 'Featured Neighborhood' }">
      <AtomsOverviewItemGroupHeading>
        {{ group.areaTitle }}
      </AtomsOverviewItemGroupHeading>
    </li>
    <li
      class="border-b-2 border-gray-400/50"
      v-for="item in group.items"
    >
      <MoleculesOverviewItem
        :item-raw-data="item"
        :tab-id="tabId"
        :plans="group.plans"
      />
    </li>
  </ul>
</template>

<script setup>
const props = defineProps({
  group: Object,
  tabId: String,
});
</script>
